// @generated by protoc-gen-es v1.2.0 with parameter "target=ts,import_extension=.ts"
// @generated from file protogen/facts.proto (package protogen, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { Attachment } from "./common_pb.ts";

/**
 * @generated from message protogen.FactStub
 */
export class FactStub extends Message<FactStub> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: string valueType = 3;
   */
  valueType = "";

  /**
   * @generated from field: string value = 4;
   */
  value = "";

  /**
   * @generated from field: int64 creationTimeSec = 5;
   */
  creationTimeSec = protoInt64.zero;

  /**
   * @generated from field: repeated protogen.Attachment attachments = 6;
   */
  attachments: Attachment[] = [];

  /**
   * @generated from field: float sortOrder = 7;
   */
  sortOrder = 0;

  /**
   * @generated from field: string sectionRef = 8;
   */
  sectionRef = "";

  constructor(data?: PartialMessage<FactStub>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.FactStub";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "valueType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "creationTimeSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "attachments", kind: "message", T: Attachment, repeated: true },
    { no: 7, name: "sortOrder", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 8, name: "sectionRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FactStub {
    return new FactStub().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FactStub {
    return new FactStub().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FactStub {
    return new FactStub().fromJsonString(jsonString, options);
  }

  static equals(a: FactStub | PlainMessage<FactStub> | undefined, b: FactStub | PlainMessage<FactStub> | undefined): boolean {
    return proto3.util.equals(FactStub, a, b);
  }
}

/**
 * @generated from message protogen.FactSectionStub
 */
export class FactSectionStub extends Message<FactSectionStub> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: float sortOrder = 3;
   */
  sortOrder = 0;

  /**
   * @generated from field: string entityType = 4;
   */
  entityType = "";

  /**
   * @generated from field: string entityRef = 5;
   */
  entityRef = "";

  constructor(data?: PartialMessage<FactSectionStub>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.FactSectionStub";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "sortOrder", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "entityType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "entityRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FactSectionStub {
    return new FactSectionStub().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FactSectionStub {
    return new FactSectionStub().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FactSectionStub {
    return new FactSectionStub().fromJsonString(jsonString, options);
  }

  static equals(a: FactSectionStub | PlainMessage<FactSectionStub> | undefined, b: FactSectionStub | PlainMessage<FactSectionStub> | undefined): boolean {
    return proto3.util.equals(FactSectionStub, a, b);
  }
}

